import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportReportAttendanceHostDetail = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/host/details/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportReportAttendanceHostDetail;
